import _ from 'lodash'
import { actionTypes } from '../actions'

const initialState = {
  docked: false,
}

export default function ContextPaneReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.TOGGLE_CONTEXT_PANE:
      return { ...state, docked: !state.docked }

    case actionTypes.INIT_CONTEXT_PANE:
      return { ...state, docked: action.payload }

    default:
      return state
  }
}
